import { FC } from 'react'
import Typography from '@/ui/components/typography'
import { useCustomTheme } from '@/core/theme'
import { DisplayCardProps } from './DisplayCard.types'
import { DisplayCardContainer } from './DisplayCard.styles'

const DisplayCard: FC<DisplayCardProps> = ({ name, children }) => {
    const theme = useCustomTheme()

    return (
        <DisplayCardContainer>
            <Typography
                variant="m-regular"
                color={theme.colors.greys[900]}
                whiteSpaceRule="nowrap"
                data-testid="display-card-title"
            >
                {name}
            </Typography>
            {children}
        </DisplayCardContainer>
    )
}

export default DisplayCard
